import { useNavigate } from 'react-router-dom';

import { useAuthStore } from '../store/auth.store';

export function useAuth() {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);
  const storeLogout = useAuthStore((s) => s.logout);
  const navigate = useNavigate();

  const logout = () => {
    storeLogout();
    navigate('/login');
  };

  return { user, isAuthenticated, isLoading, logout };
}
